export type Association = 'ABMP' | 'ASCP' | 'AHP' | 'ANP';

export const Associations: Association[] = ['ABMP', 'ASCP', 'AHP', 'ANP'];

export const AsnName: {[Asn in Association]: string}  = {
  'ABMP' : 'Associated Bodywork & Massage Professionals',
  'ASCP' : 'Associated Skin Care Professionals',
  'AHP' : 'Associated Hair Professionals',
  'ANP' : 'Associated Nail Professionals'
};

export const AsnLogo: {[Asn in Association]: string}  = {
  'ABMP' : 'https://cdn.abmp.com/sites/abmp.com/themes/abmp/favicon.ico',
  'ASCP' : 'https://public.ascpskincare.com/sites/ascpskincare.com/themes/ascpskincare/favicon.ico',
  'AHP' : 'https://www.associatedhairprofessionals.com/sites/associatedhairprofessionals.com/themes/ahp/favicon.ico',
  'ANP' : 'https://www.nailprofessional.com/sites/nailprofessional.com/themes/anp/logo.png'
};

export const AsnLicenseType: {[Asn in Association]: string}  = {
  'ABMP' : 'Massage / Bodywork',
  'ASCP' : 'Esthetician',
  'AHP' : 'Cosmetology',
  'ANP' : 'Nail'
};

export const AsnWizardLabel: {[Asn in Association]: string}  = {
  'ABMP' : 'Massage / Bodywork',
  'ASCP' : 'Skin Care / Esthetics',
  'AHP' : 'Cosmetology / Hairstyling',
  'ANP' : 'Nail Care'
};

export interface AsnInfo {
  code: Association;
  logo: string;
  name: string;
  label: string;
  license: string;
}

export const AsnInfomation: {[Asn in Association]: AsnInfo}  = {
  'ABMP' : {
    code: 'ABMP',
    logo: AsnLogo['ABMP'],
    name: AsnName['ABMP'],
    label: AsnWizardLabel['ABMP'],
    license: AsnLicenseType['ABMP']
  },
  'ASCP' : {
    code: 'ASCP',
    logo: AsnLogo['ASCP'],
    name: AsnName['ASCP'],
    label: AsnWizardLabel['ASCP'],
    license: AsnLicenseType['ASCP']
  },
  'AHP' : {
    code: 'AHP',
    logo: AsnLogo['AHP'],
    name: AsnName['AHP'],
    label: AsnWizardLabel['AHP'],
    license: AsnLicenseType['AHP']
  },
  'ANP' : {
    code: 'ANP',
    logo: AsnLogo['ANP'],
    name: AsnName['ANP'],
    label: AsnWizardLabel['ANP'],
    license: AsnLicenseType['ANP']
  }
};

export const AsnInformationArray: AsnInfo[] = Object.values(AsnInfomation);
